<mapfre-auditlib-file-uploader [form]="form" [label]="label" (change)="onChangeUpload($event)">
</mapfre-auditlib-file-uploader>

<mapfre-auditlib-modal [(visible)]="display">
    <div class="custom-modal">
        <div>
            <h3>{{ 'MODAL.UP_IMAGE' | translate }}</h3>
        </div>
        <div>
            <image-cropper [imageChangedEvent]="imageToCrop" [maintainAspectRatio]="cropperOptions?.maintainAspectRatio"
                [aspectRatio]="cropperOptions?.aspectRatio" [resizeToWidth]="cropperOptions?.resizeToWidth"
                [format]="cropperOptions?.format" (imageCropped)="imageCropped($event)"></image-cropper>

            <p-footer>
                <div class="mt-3 d-flex justify-content-end align-bottom">
                    <mapfre-auditlib-button class="me-3" type="button" icon="pi pi-check" (click)="submit()">
                        <div class="pe-3 ps-3">{{ 'FORM.GENERIC_LABELS.ACCEPT' | translate }}</div>
                    </mapfre-auditlib-button>
                    <mapfre-auditlib-button type="button" icon="pi pi-close" (click)="cancel()"
                        class="p-button-secondary me-2 ">
                        <div class="pe-3 ps-3">{{ 'FORM.GENERIC_LABELS.CANCEL' | translate }}</div>
                    </mapfre-auditlib-button>
                </div>
            </p-footer>
        </div>
    </div>
</mapfre-auditlib-modal>


<!-- 
    
<p-dialog header="Subir Imagen" [(visible)]="display" [modal]="true" [responsive]="true" [style]="{width: '350px', minWidth: '200px'}" [minY]="70"
        [baseZIndex]="10000" (onHide)="cancel()">
        
        <div>
                <h3>Subir Imagen</h3>
            </div>
            <div>
                <image-cropper
                    [imageChangedEvent]="imageToCrop"
                    [maintainAspectRatio]="true"
                    [aspectRatio]="4 / 3"
                    [resizeToWidth]="100"
                    format="png"
                    (imageCropped)="imageCropped($event)"    
                ></image-cropper>
                
                <img class="cropped-image" [src]="newImage" />
                <p-footer>
                    <button type="button" pButton icon="pi pi-check" (click)="submit()" label="Yes"></button>
                    <button type="button" pButton icon="pi pi-close" (click)="cancel()" label="No" class="p-button-secondary"></button>
                </p-footer>
            </div>
</p-dialog>

-->